var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.channelId)?_c('ChannelPage',{attrs:{"channelId":_vm.channelId}}):(_vm.productId)?_c('ProductPage',{attrs:{"productId":_vm.productId}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }